module.exports = __webpack_public_path__ + "img/vignettes-asso_0003_sumba.fc1e8fee.jpg";